module.exports = __webpack_public_path__ + "static/42-189f92918f7395ededc3cbd4fa203395.png";